
import { User, SortColumn, SortDirection } from "@/hooks/useUserManagement";
import { Table, TableBody } from "@/components/ui/table";
import { UsersTableHeader } from "./UsersTableHeader";
import { UsersTableRow } from "./UsersTableRow";
import { UsersTableStatus } from "./UsersTableStatus";

interface UsersTableProps {
  users: User[];
  loading: boolean;
  sortColumn: SortColumn;
  sortDirection: SortDirection;
  onSort: (column: SortColumn) => void;
  onDelete: (user: User) => void;
}

export function UsersTable({
  users,
  loading,
  sortColumn,
  sortDirection,
  onSort,
  onDelete,
}: UsersTableProps) {
  const isEmpty = users.length === 0;

  return (
    <div className="bg-card rounded-lg overflow-hidden border border-border/40">
      <Table>
        <UsersTableHeader
          sortColumn={sortColumn}
          sortDirection={sortDirection}
          onSort={onSort}
        />
        <TableBody>
          <UsersTableStatus loading={loading} isEmpty={isEmpty} />
          
          {!loading && !isEmpty && users.map((user) => (
            <UsersTableRow 
              key={user.id}
              user={user} 
              onDelete={onDelete}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
